
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import SoftwareAdminPanel from "./SoftwareAdmin/SoftwareAdminPanel";
import UserAdminPanel from "./UserAdmin/UserAdminPanel";

const DividerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  minHeight: 50
}));


export default function User() {
  const { roles, user } = useSelector(state => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  
  useEffect(() => {
    localStorage.removeItem('projectData');
    localStorage.removeItem('itemData');
  }, []);
  
  
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <DividerHeader />
      {isUser?.code === 'mvedasMasterAdmin' || isUser?.code === 'mvedasAdmin'  ? (
        <SoftwareAdminPanel isUser={isUser} />
      ) : (
        <UserAdminPanel isUser={isUser} />
      )}
    </Box>
  )
}